import {assignBrowserLocation, logError} from "./main/api/BrowserWrapper";
import {globalErrorHandlerEnabled} from "./main/utils/envUtil";

export function registerUnhandledRejectionHandler() {
     if (globalErrorHandlerEnabled()) {
         window.addEventListener("unhandledrejection", (promiseRejectionEvent: PromiseRejectionEvent) => {
             logError("Unhandled Promise Rejection:", promiseRejectionEvent.reason);
             assignBrowserLocation("/error.html");
         });
     }
}
